// extracted by mini-css-extract-plugin
export default {"actionsRow":"sign-requests-graph_actionsRow__8LaD7","switchWrapper":"sign-requests-graph_switchWrapper__tp6Vb","switchLabel":"sign-requests-graph_switchLabel__yKex1"};